module.exports = __webpack_public_path__ + "img/nkp-logo.c5baa4af.svg";